<!-- Bootstrap Button Row -->
<div class="d-flex gap-2 mb-3">
  <button
    *ngFor="let tab of tabs; let i = index"
    class="btn"
    [ngClass]="{
      'btn-primary': activeIndex === i,
      'btn-outline-secondary': activeIndex !== i
    }"
    (click)="activeIndex = i; adjustHeight()"
  >
    {{ tab.label }}
  </button>
</div>

<!-- Content Area -->
<div #stepperContainer class="position-relative overflow-hidden w-100">
  <div
    class="d-flex transition-all"
    [style.width.%]="tabs.length * 100"
    [style.transform]="'translateX(-' + (activeIndex * (100 / tabs.length)) + '%)'"
    style="transition: transform 0.4s ease-in-out;"
  >
    <div
      #stepContent
      *ngFor="let tab of tabs"
      class="flex-shrink-0"
      [style.width.%]="100 / tabs.length"
    >
      <ng-container *ngTemplateOutlet="tab.template"></ng-container>
    </div>
  </div>
</div>
